// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96b43fde","667":"b2d2aa82","977":"9f2806b0"}[chunkId] + ".chunk.js";
};